import { render, staticRenderFns } from "./DomainPool.vue?vue&type=template&id=0b1f6413&scoped=true&"
import script from "./DomainPool.vue?vue&type=script&lang=ts&"
export * from "./DomainPool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f6413",
  null
  
)

export default component.exports